import React from 'react';
import { CheckCircle, Users, MessageCircle, Gift, X } from 'lucide-react';
import { Modal, Button } from '../ui';

interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureType: string;
  amount: number;
  onContinue?: () => void;
}

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({
  isOpen,
  onClose,
  featureType,
  amount,
  onContinue
}) => {
  
  const getFeatureIcon = (featureType: string) => {
    switch (featureType) {
      case 'EXTRA_GROUP_SLOTS':
        return <Users className="w-12 h-12 text-neon-cyan" />;
      case 'EXTENDED_GROUP_SIZE':
        return <Users className="w-12 h-12 text-neon-cyan" />;
      case 'CHAT_ENHANCEMENTS':
        return <MessageCircle className="w-12 h-12 text-neon-cyan" />;
      default:
        return <Gift className="w-12 h-12 text-neon-cyan" />;
    }
  };

  const getFeatureTitle = (featureType: string) => {
    switch (featureType) {
      case 'EXTRA_GROUP_SLOTS':
        return 'Extra Groep Plekken Geactiveerd!';
      case 'EXTENDED_GROUP_SIZE':
        return 'Groep Uitbreiding Geactiveerd!';
      case 'CHAT_ENHANCEMENTS':
        return 'Chat Verbeteringen Geactiveerd!';
      default:
        return 'Premium Feature Geactiveerd!';
    }
  };

  const getFeatureDescription = (featureType: string) => {
    switch (featureType) {
      case 'EXTRA_GROUP_SLOTS':
        return 'Je kunt nu in meer groepen tegelijkertijd! De nieuwe limiet is direct actief.';
      case 'EXTENDED_GROUP_SIZE':
        return 'Je groep kan nu meer leden hebben! De nieuwe capaciteit is direct beschikbaar.';
      case 'CHAT_ENHANCEMENTS':
        return 'Je kunt nu GIFs sturen in je groep chats! Maak je gesprekken nog leuker.';
      default:
        return 'Je premium feature is succesvol geactiveerd en direct beschikbaar!';
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <div className="w-full relative">
        {/* Close button */}
        <div className="absolute top-4 right-4">
          <button
            onClick={onClose}
            className="text-fg-muted hover:text-fg-bright transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Success Header */}
        <div className="px-8 pt-10 pb-6 text-center">
          <div
            className="w-20 h-20 mx-auto mb-4 rounded-full bg-neon-lime/[.12] flex items-center justify-center"
            style={{ boxShadow: '0 0 40px rgba(184,255,61,.35)' }}
          >
            <CheckCircle className="w-10 h-10 text-neon-lime" />
          </div>
          <h2 className="text-2xl font-bold text-fg-bright mb-2">
            Betaling Succesvol! 🎉
          </h2>
          <p className="text-fg-muted">
            Je premium feature is direct beschikbaar
          </p>
        </div>

        {/* Content */}
        <div className="px-8 py-6 text-center">
          <div className="mb-6">
            <div className="flex justify-center mb-4">
              {getFeatureIcon(featureType)}
            </div>
            <h3 className="text-xl font-bold text-fg-bright mb-2">
              {getFeatureTitle(featureType)}
            </h3>
            <p className="text-fg-body">
              {getFeatureDescription(featureType)}
            </p>
          </div>

          {/* Amount */}
          <div className="sf-card-highlight p-4 mb-6">
            <p className="sf-label-mono mb-1">Betaald bedrag</p>
            <p className="text-3xl font-bold text-fg-bright">
              €{amount.toFixed(2)}
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              onClick={onContinue || onClose}
              className="w-full py-3 text-lg"
            >
              Perfect! Ga verder
            </Button>
            <button
              onClick={onClose}
              className="sf-link"
            >
              Sluiten
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentSuccessModal;